import Joi from '@hapi/joi'

export const CommonOperationCardSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityId: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointId: Joi.number().invalid().allow("", null).label("Collectionpoint").messages({
        "any.invalid": `Select collectionpoint`,
        "any.required": `collectionpoint required`
    }),
}

export const CommonOperationCardSchemaObjectEdit = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid().allow("", null).label("Collectionpoint").messages({
        "any.invalid": `Select collectionpoint`,
        "any.required": `collectionpoint required`
    }),
    collectionCatagoryID: Joi.number().invalid().allow("", null).label("collectionCatagory").messages({
        "any.invalid": `Select collectionCatagoryID`,
        "any.required": `collectionCatagoryID required`
    })
}